import numeral from "numeral";
import React from "react";
import { CardMain } from "../../../components/card/CardMain";
import Container from "../../../components/layout/Container";
import { cn } from "../../../utils/useFunctions";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PARENT_PADDING,
  STYLE_TEXT_BLUE,
} from "../../../utils/useStyle";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { STYLE_PAGE } from "../styles/pdf.style";
import { tax405Percent } from "../../../functions/taxFucntion/premium/businessFunction";

const Income408Recive = ({
  page,
  taxData = {},
  allList = [],
  isFirst = false,
}) => {

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="วางแผนภาษี"
        icon="/images/tax_plan.svg"
        classNameIcon="w-[24px] h-[27px]"
      />

      <Container classnameInner={""}>
        <div className={STYLE_MARGIN_TOP_PARENT}>
          <div className={STYLE_PARENT_PADDING}>
            <CardMain
              border={false}
              icon={false}
              marginyellow="mt-0"
              padding=" py-0 "
              panel={
                <div className=" px-3 -mt-3">
                  <div className="text-[12px] font-[500]">
                    เงินได้จากการให้หรือการรับ (มาตรา 40(8))
                  </div>
                </div>
              }
            />
            <CardMain
              border={false}
              icon={false}
              marginyellow="mt-3"
              panel={
                <div className=" px-3 -mt-3">
                  <div className="text-[12px] font-[500] py-[5px]">
                    เงินได้จากการโอนกรรมสิทธิ / สิทธิครอบครอง
                    ในอสังหาริมทรัพย์ตามมาตรา 42 (26)
                  </div>
                  <div className="w-full flex justify-between text-[11px] font-[500]">
                    <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                      เงินได้พึงประเมิน
                    </div>
                    <div
                      className={cn(STYLE_TEXT_BLUE, {
                        "w-fit whitespace-nowrap": true,
                      })}
                    >
                      {" "}
                      {`${numeral(taxData?.heritage?.income_42_26).format(
                        "0,0"
                      )} บาท`}{" "}
                    </div>
                  </div>
                  <div className="w-full flex justify-between text-[11px] font-[500]">
                    <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                      ภาษีหัก ณ ที่จ่าย
                    </div>
                    <div
                      className={cn(STYLE_TEXT_BLUE, {
                        "w-fit whitespace-nowrap": true,
                      })}
                    >
                      {" "}
                      {`${numeral(
                        taxData?.heritage?.withholging_tax_42_26
                      ).format("0,0")} บาท`}{" "}
                    </div>
                  </div>
                  <div className="text-[12px] font-[500] py-[5px]">
                    เงินได้ที่ได้รับจากการอุปการะ/จากการให้ โดยเสน่หาจากบุพการี
                    ตามมาตรา 42 (27)
                  </div>
                  <div className="w-full flex justify-between text-[11px] font-[500]">
                    <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                      เงินได้พึงประเมิน
                    </div>
                    <div
                      className={cn(STYLE_TEXT_BLUE, {
                        "w-fit whitespace-nowrap": true,
                      })}
                    >
                      {" "}
                      {`${numeral(taxData?.heritage?.income_42_27).format(
                        "0,0"
                      )} บาท`}{" "}
                    </div>
                  </div>
                  <div className="text-[12px] font-[500] py-[5px]">
                  เงินได้ที่ได้รับจากการอุปการะโดยหน้าที่ธรรมจรรยา /จากการให้โดยเสน่หาฯ ตามมาตรา 42 (28)
                  </div>
                  <div className="w-full flex justify-between text-[11px] font-[500]">
                    <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                      เงินได้พึงประเมิน
                    </div>
                    <div
                      className={cn(STYLE_TEXT_BLUE, {
                        "w-fit whitespace-nowrap": true,
                      })}
                    >
                      {" "}
                      {`${numeral(taxData?.heritage?.income_42_28).format(
                        "0,0"
                      )} บาท`}{" "}
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </Container>
      <PdfFooter page={page} />
    </div>
  );
};

export default Income408Recive;
